import React from 'react';
import PropTypes from 'prop-types';

const LinkIcon = ({ className }) => {
    return (

        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            className={`fill-current ${className}`}
            fill="currentColor" // Ensures the color can be changed dynamically
            >
            <path d="M12.7562 15.8081L9.96057 18.6037C9.3558 19.2085 8.54564 19.5508 7.67842 19.5508C6.8112 19.5508 6.01244 19.2199 5.39626 18.6037C4.78008 17.9876 4.44917 17.1888 4.44917 16.3216C4.44917 15.4544 4.78008 14.6556 5.39626 14.0394L8.19191 11.2438C8.32884 11.1068 8.40871 10.9243 8.40871 10.7303C8.40871 10.5363 8.32884 10.3537 8.19191 10.2168C8.05498 10.0799 7.8724 10 7.67842 10C7.48443 10 7.30187 10.0799 7.16494 10.2168L4.36929 13.0124C3.47925 13.8911 3 15.0778 3 16.3216C3 17.5654 3.49066 18.7521 4.36929 19.6307C5.24792 20.5093 6.42323 21 7.67842 21C8.9336 21 10.1089 20.5093 10.9875 19.6307L13.7832 16.8351C13.9201 16.6981 14 16.5156 14 16.3216C14 16.1276 13.9201 15.945 13.7832 15.8081C13.5093 15.5342 13.0301 15.5342 12.7448 15.8081H12.7562Z" fill="currentColor"/>
            <path d="M19.6108 4.37072C17.7888 2.54309 14.8282 2.54309 13.0062 4.37072L10.2164 7.16926C10.0797 7.30634 10 7.4891 10 7.68328C10 7.87747 10.0797 8.06023 10.2164 8.1973C10.4897 8.47144 10.9679 8.47144 11.2526 8.1973L14.0424 5.39875C14.6687 4.77051 15.4886 4.45067 16.3199 4.45067C17.1511 4.45067 17.971 4.77051 18.5973 5.39875C19.2008 6.00415 19.5424 6.81516 19.5424 7.68328C19.5424 8.5514 19.2122 9.35099 18.5973 9.96781L15.8075 12.7664C15.6708 12.9034 15.5911 13.0862 15.5911 13.2804C15.5911 13.4746 15.6708 13.6573 15.8075 13.7944C16.0808 14.0685 16.5704 14.0685 16.8437 13.7944L19.6335 10.9958C20.5217 10.1049 21 8.92835 21 7.68328C21 6.43821 20.5104 5.25026 19.6335 4.37072H19.6108Z" fill="currentColor"/>
            <path d="M8.20388 15.7666C8.47573 16.0778 8.95146 16.0778 9.23463 15.7666L14.7848 9.41329C14.9207 9.2577 15 9.05024 15 8.82982C15 8.6094 14.9207 8.40195 14.7848 8.24635C14.6489 8.09076 14.4563 8 14.2751 8C14.0939 8 13.9013 8.0778 13.7654 8.24635L8.21521 14.5997C8.07929 14.7553 8 14.9627 8 15.1831C8 15.4036 8.07929 15.611 8.21521 15.7666H8.20388Z" fill="currentColor"/>
        </svg>

    );
};

LinkIcon.propTypes = {
    className: PropTypes.string, // Optional: allows passing Tailwind or custom classes
};

LinkIcon.defaultProps = {
    className: '', // Default to an empty string
};

export default LinkIcon;